import type { TChapterData } from '../types';

/**
 * 将 API 返回的原始 HTML 章节内容解析为 TChapterData。
 *
 * 真实接口返回的 content 字段是一整段 HTML 字符串，形如：
 *   "<p>段落一</p><p>段落二</p>..."
 *
 * 处理步骤：
 * 1. 清理噪声：去掉换行符、<br>、<img>、<a href>（保留链接文字）、<style>、&nbsp;、空段落
 * 2. 用正则逐一提取 <p>...</p> 内的文本
 * 3. 对每段再 strip 剩余标签，trim，前置两个全角空格缩进
 * 4. 以标题作为第一项，后续为正文段落，构成 TChapterData 返回
 */
export function formatContent(title: string, htmlContent: string): TChapterData {
    const cleaned = (htmlContent || '')
        .replace(/\n|\r|\t/g, '')
        .replace(/<br\s*\/?>/gi, '')
        .replace(/<img\s[^>]*>(<\/img>)?/gi, '')
        .replace(/<a([^>]*)\shref="[^"]*"/gi, '<a$1') // 去掉 href，保留链接文字
        .replace(/\{!--.*?PGC_.*?--\}/g, '') // 去掉 PGC 富文本注释
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/&nbsp;/g, '')
        .replace(/<p[^>]*>\s*<\/p>/gi, ''); // 去掉空段落

    const result: TChapterData = [{ type: 'html', htmlTag: 'title', html: title }];

    // 兼容：只有开始 <p> 没有结束 </p>，或内容直接以 <p> 分隔的情况
    const reg = /<p[^>]*>([\s\S]*?)(<\/p>|(?=<p)|$)/gi;
    let match = reg.exec(cleaned);

    while (match !== null) {
        const raw = match[1];
        if (raw) {
            const text = raw
                .replace(/<[^>]*>/g, '') // strip 剩余行内标签
                .trim();
            if (text) {
                result.push({ type: 'html', htmlTag: 'p', html: text });
            }
        }
        match = reg.exec(cleaned);
    }
    return result;
}
